import React from 'react'
import image from '@loyal_images/products/product_placeholder.png'

const ListPlaceholder = props => {
  return (
    <div className='cart-side col-12 col-md-8 px-0 pr-md-2 mb-2 mb-md-0'>
      <div className='border-ui-3 radius bg-white'>
        <div className='col-12 py-4 px-3 mx-0 border-color-ui-3 border-bottom'>
          <div className='row mx-0 shimmer'>
            <div className='col-6 py-half bg-ui-3 radius' />
          </div>
        </div>
        <div className='cart-products col-12 pb-1 mx-0'>
          <div className='cart-item row px-2 border-color-ui-3 border-bottom py-2'>
            <div className='cart-img col-auto txt-center pl-1 pt-1 pb-1 pr-2'>
              <img src={image} alt='Produto está carregando...' />
            </div>
            <div className='cart-product-info col col-md'>
              <div className='row'>
                <div className='col col-md'>
                  <div className='cart-product-info row'>
                    <div className='product-infos col-12 mx-0'>
                      <div className='row mx-0'>
                        <div className='col-10 py-half bg-ui-4 radius' />
                      </div>
                      <div className='row mx-0 mt-1'>
                        <div className='col-6 py-half bg-ui-4 radius' />
                      </div>
                      <div className='row mx-0 mt-2'>
                        <div className='col-4 py-half bg-ui-4 radius' />
                      </div>
                      <div className='row mx-0 mt-2'>
                        <div className='col-7 py-half bg-ui-4 radius' />
                      </div>
                    </div>
                  </div>
                </div>
                <div className='cart-action pos-relative col-12 col-md-2 txt-center'>
                  <div className='cart-action-row row align-items-center h-100'>
                    <div className='col-12'>
                      <div className='row mx-0 mt-2'>
                        <div className='col-4 col-md-12 py-2 bg-ui-4 radius' />
                      </div>
                      <div className='cart-product-remove'>
                        <div className='row mx-0 mt-2'>
                          <div className='col-4 col-md-7 mr-auto ml-0 ml-md-auto py-half bg-ui-4 radius' />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='row px-1 px-md-3 bg-ui-5  border-color-ui-3 border-bottom py-2'>
            <div className='cart-shipping h-auto col-12 px-0'>
              <div className='row mx-0 align-items-center h-100'>
                <div className='col-auto'>
                  <span className='d-block pt-2 pb-half pl-2 pr-half bg-ui-3 radius-circle' />
                </div>
                <div className='col col-md-2 color-brand-1'>
                  <div className='row mx-0'>
                    <div className='col-10 py-half bg-white radius' />
                  </div>
                  <div className='row mx-0 mt-1 d-none d-md-block'>
                    <div className='col-7 mr-auto py-half bg-white radius' />
                  </div>
                </div>
                <div className='shippingNotCalculated mt-2 mt-md-0 px-2 px-md-0 col-12 col-md-7'>
                  <div className='row shimmer'>
                    <div className='col-7 pt-3 pb-2 mr-1  bg-white radius' />
                    <div className='col-4 pt-3 pb-2  bg-ui-3 radius' />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='row pb-2 pt-3 px-3 px-half'>
            <div className='col-6 py-half bg-ui-4 radius' />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ListPlaceholder



// WEBPACK FOOTER //
// ./src/features/Cart/List/ListPlaceholder.js